export default __webpack_public_path__ + "/assets/fonts/inria-serif-latin-ext-400-normal.woff2";